import constants from './constants';
const initialState = {
    loading: false,
    error: null,
    response : null,
};
export const secureMessageReducer = (state = initialState , action)=> {
    switch(action.type){
        case constants.SEND_SECURE_MESSAGE_BEGIN : {
            return {...state , loading: true, error: null};
        }
        case constants.SEND_SECURE_MESSAGE_SUCCESS: {
    
            return {...state , loading : false, response: action.payload};
        }
        case constants.SEND_SECURE_MESSAGE_ERROR: {
            return {...state, loading: false, error: action.payload};
        }
        case constants.SEND_SECURE_MESSAGE_CLEANUP: return initialState;
        default: return state;
    }
};